
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Case Battles',
    tabActive: 'Active',
    tabHistoryAll: 'Completed',
    tabHistoryMine: 'My Battles',
    createBattle: 'Create Battle',
    empty: 'No active battles',
    emptyHistory: 'No battle history',
    loading: 'Loading...',
    historyMineLoginReason: 'Sign in to see your battles.',
    refreshFailed: "Couldn't refresh — showing the last loaded battles",
  },
  ru: {
    title: 'Case Battles',
    tabActive: 'Активные',
    tabHistoryAll: 'Завершенные',
    tabHistoryMine: 'Мои баттлы',
    createBattle: 'Создать баттл',
    empty: 'Нет активных баттлов',
    emptyHistory: 'Нет истории баттлов',
    loading: 'Загрузка...',
    historyMineLoginReason: 'Войди, чтобы видеть свои баттлы.',
    refreshFailed: 'Не удалось обновить, показаны последние данные',
  },
  uz: {
    title: 'Keys Janglar',
    tabActive: 'Faol',
    tabHistoryAll: 'Tugallangan',
    tabHistoryMine: 'Mening janglarim',
    createBattle: "Jang yaratish",
    empty: 'Faol janglar yoʻq',
    emptyHistory: 'Jang tarixi yoʻq',
    loading: 'Yuklanmoqda...',
    historyMineLoginReason: 'Oʻz janglaringizni koʻrish uchun kiring.',
    refreshFailed: 'Yangilab boʻlmadi — oxirgi yuklangan janglar koʻrsatilmoqda',
  },
  fa: {
    title: 'نبرد کیس',
    tabActive: 'فعال',
    tabHistoryAll: 'تمام‌شده',
    tabHistoryMine: 'نبردهای من',
    createBattle: 'ساخت نبرد',
    empty: 'نبرد فعالی نیست',
    emptyHistory: 'تاریخچه نبردی نیست',
    loading: 'در حال بارگذاری...',
    historyMineLoginReason: 'وارد شو تا نبردهایت را ببینی.',
    refreshFailed: 'به‌روزرسانی نشد — آخرین نبردهای بارگذاری‌شده را نشان می‌دهیم',
  },
});
